import { Dropdown, DropdownItem, DropdownMenu, List, Menu } from 'semantic-ui-react';
import './footer.css';

const Footer = () => {
  return (
    <footer id="footer">
      <nav role='navigation' id="desk-footer" className='text-center'>
        <List celled horizontal>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/">Home</a></List.Item>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/courts/home.html">
            Virginia's Court System
          </a></List.Item>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/online/home.html">
            Online Services
          </a></List.Item>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/caseinfo/home.html">
            Case Status and Information
          </a></List.Item>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/courtadmin/home.html">
            Court Administration
          </a></List.Item>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/directories/home.html">
            Directories
          </a></List.Item>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/forms/home.html">
            Forms
          </a></List.Item>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/agencies/home.html">
            Judicial Branch Agencies
          </a></List.Item>
          <List.Item><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/programs/home.html">
            Programs
          </a></List.Item>
        </List>
      </nav>

      <Menu fluid role="navigation" id="mobile-footer">
        <Dropdown
          icon="bars"
          button
          className="icon"
          aria-label="links"
        >
          <DropdownMenu>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/">Home</a></DropdownItem>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/courts/home.html">Virginia's Court System</a></DropdownItem>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/online/home.html">Online Services</a></DropdownItem>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/caseinfo/home.html">
              Case Status and Information
            </a></DropdownItem>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/courtadmin/home.html">
              Court Administration
            </a></DropdownItem>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/directories/home.html">
              Directories
            </a></DropdownItem>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/forms/home.html">
              Forms
            </a></DropdownItem>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/agencies/home.html">
              Judicial Branch Agencies
            </a></DropdownItem>
            <DropdownItem><a target="_blank" rel="noreferrer" className="foot-link" href="https://www.vacourts.gov/programs/home.html">
              Programs
            </a></DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Menu>
    </footer>
  );
};

export default Footer;
